import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, takeUntil, Subscription } from 'rxjs';
import { DepartmentsService } from 'src/app/admin/data/services/departments.service';

import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { AddGivingComponent } from '../../giving/add-giving/add-giving.component';
import { AccountService } from '../../users/data/services/account.service';
import { TokenStorageService } from 'src/app/core/service/token-storage.service';


@Component({
  selector: 'app-community-check',
  templateUrl: './community-check.component.html',
  styleUrls: ['./community-check.component.sass']
})
export class CommunityCheckComponent implements OnInit {


  displayedColumns: string[] = [
    "select",
    "id",
    "community",

    "church",
     "members",
      "families",

   
  ];

  dataSource!: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  
  contextMenu: MatMenuTrigger;
  subscription!: Subscription;
  selection = new SelectionModel<any>(true, []);
  data: any;
  error: any;

  formData: any;

  isLoading = true;

  

  commuinityDetails: any;
  selectedRows: any[] = [];
  atleastOneSelected: boolean = false;

  dataSourceFilteredList: any[] = [];
  commuinityArray: any[] = [];

  destroy$: Subject<boolean> = new Subject<boolean>();



  constructor(
    public dialogRef: MatDialogRef<AddGivingComponent>,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private snackbar: SnackbarService,
    private accountService: AccountService,
    private deptService: DepartmentsService,
    private tokenStorage: TokenStorageService
  ) { }

  ngOnInit(): void {
  
    this.getData();

   

  }
  ngAfterViewInit() {

    console.log("Finally: ", this.dataSourceFilteredList);

   
  }


  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  filter() {
    //let storeId = [1, 2, 3];
    this.dataSource.data.forEach((element) => {
      this.commuinityArray.forEach((item) => {
        if (item === element.id) {
          // this.dataSourceFilteredList.push(this.dataSource.data.indexOf(element));
          this.selection.select(element);
        }
      });
    });

  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  //******************************************************************************************************
  //Select expense

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "deselect" : "select"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${row.position + 1
      }`;
  }

  expSelected() {
    this.atleastOneSelected = true;
    this.selectedRows = this.selection.selected;

  
  }
  proceed() {
    this.dialogRef.close({ event: "close", data: this.selectedRows });

    //   console.log(data);
  }

  onNoClick(): void {
    this.dialogRef.close({ event: "close", data: this.selectedRows });
  }
  public confirmAdd(): void { }

  getData() {
    var parishId = this.tokenStorage.getUser().parishId;
    this.subscription = this.accountService.getAllCommunities(parishId).subscribe(res => {
      this.data = res;
     

      if (this.data) {
        this.isLoading = false;
      }


      // Binding with the datasource
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    })
  }



  selectedcommuinity: any[] = [];

  commuinityLookup(commuinityId) {
    // const dialogConfig = new MatDialogConfig();
    // dialogConfig.disableClose = false;
    // dialogConfig.autoFocus = true;
    // dialogConfig.width = "700px";
    // dialogConfig.data = {
    //   action: "view Families",
    //   selected: this.selectedcommuinity,
     
    //   commuinityId: commuinityId
    // };
  
    // console.log("check this",commuinityId);
    // const dialogRef = this.dialog.open(commuinityMembersComponent, dialogConfig);
    //   dialogRef.afterClosed().subscribe((result) => {
    //     this.getData();

    //   });
    
  }
  



}
